import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ImageSelector from '@di-shared/features/common/ImageSelector';

function TireWarningBottomSheet() {
  const {t} = useInferableTranslation();
  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T30310')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <div className="tire_intro">
            <ImageSelector
              className="tire_intro_img"
              alt="tire_intro_img"
              kiaLightSrc={() => import('@di-shared/assets/img/car_management/tire_warning_intro.png')}
              kiaDarkSrc={() => import('@di-shared/assets/img/car_management/tire_warning_intro_light.png')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/car_management/hyundai/tire_warning_intro_light.png')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/car_management/hyundai/tire_warning_intro.png')}
              genesisLightSrc={() => import('@di-shared/assets/img/car_management/genesis/tire_warning_intro_light.png')}
              genesisDarkSrc={() => import('@di-shared/assets/img/car_management/genesis/tire_warning_intro.png')}
            />
            <p className="tire_intro_desc">
              <strong
                className="text_emphasis"
                style={{whiteSpace: 'pre-wrap'}}
              >
                {t('T30311')}
              </strong>
            </p>
          </div>

          <ul className="bottom_sheet_list">
            <li className="bottom_sheet_item">{t('T30312')}</li>
            <li className="bottom_sheet_item">{t('T30313')}</li>
          </ul>
        </div>

        <div className="bottom_sheet_footer">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose()}
          >
            {t('T10114')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TireWarningBottomSheet;
